import { Builder } from '@builder.io/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useState, useEffect } from 'react'

import Slider from 'react-slick'
import Bullet from '../../../images/BulletPoint.svg'
import LinkRoute from '../../ui/link/Link'

import './index.css'
import newSticker from '../../../images/newProduct.svg'
import CdnImage from '../../util/CdnImage'
// import CloudinaryImage from '../../util/CloudinaryImage'

export interface IProps {
  recipeDescription: string
  backgroundColor: string
  articleTitleTextColor: string
  articleDescriptionTextColor: string
  articleItemBackgroundColor: string
  maxNumberToList: number
  autoplayTime: number
  recipeBulletPoint: any
  bulletAltText: string
  maxNumberOfFeature: number
  isCarousel: boolean
}

const RecipeLister = ({
  backgroundColor,
  articleTitleTextColor,
  articleDescriptionTextColor,
  articleItemBackgroundColor,
  maxNumberToList,
  autoplayTime,
  recipeBulletPoint,
  bulletAltText = '',
  maxNumberOfFeature = 3,
  isCarousel
}: IProps) => {
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <ChevronRightIcon
        onClick={onClick}
        className={`${className} recipe-lister-chevron-right h-5 w-5 sm:h-6 sm:w-6`}
        style={{
          ...style,
          top: '50% !important',
          left: '-1.5rem !important',
          transform: 'translateY(-50%) !important'
        }}
      />
    )
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <ChevronLeftIcon
        onClick={onClick}
        className={`${className} recipe-lister-chevron-left h-5 w-5 sm:h-6 sm:w-6`}
        style={{
          ...style,
          top: '50% !important',
          right: '-1.5rem !important',
          transform: 'translateY(-50%) !important'
        }}
      />
    )
  }

  const [carouselSettings, setCarouselSettings] = useState({
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  })

  useEffect(() => {
    setCarouselSettings({
      dots: false,
      autoplay: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      autoplaySpeed: autoplayTime
    })
  }, [autoplayTime, backgroundColor])

  const { allBuilderModels }: any = useStaticQuery(graphql`
    query {
      allBuilderModels {
        recipe {
          data {
            url
            title
            cloudinaryCookedImage
            cloudinaryPreCookImage
            cdnCookedImage
            cdnPreCookedImage
            features
            isHealthPlus
            description
            adultOnly
          }
        }
      }
    }
  `)

  console.log('RecipeLister::Recipes ', allBuilderModels.recipe)

  const getRecipes = () => {
    console.log('getting color here', articleItemBackgroundColor)
    const recipeArticles =
      maxNumberToList === 0 || !maxNumberToList
        ? allBuilderModels.recipe
        : allBuilderModels.recipe?.slice(0, maxNumberToList)

    return recipeArticles?.map((item: any, i: number) => {
      const recipe = item.data

      //  Need to pass new key of "features" for recipe in builder or grapgQL builder query
      const recipeFeature =
        maxNumberOfFeature === 0 || !maxNumberOfFeature
          ? item?.data?.features
          : item?.data?.features?.slice(0, maxNumberOfFeature)

      const [isMouseOver, setIsMouseOver] = useState(false)

      return (
        <>
          <div
            //  group relative
            className={`recipe-lister-item group relative flex h-full flex-col pb-4 rounded-3xl ${
              recipe?.adultOnly ? '' : 'overflow-hidden'
            }`}
            key={i}
            style={{ backgroundColor: articleItemBackgroundColor }}
          >
            {recipe.isHealthPlus && (
              <span
                style={{ fontSize: '0.65rem', lineHeight: '1rem', top: '0.5rem', right: '0.5rem' }}
                className="absolute z-30 inline-flex h-11 w-11 -rotate-12 items-center justify-center rounded-full bg-ddGreen text-center drop-shadow md:hidden md:h-14 md:w-14 xl:inline-flex"
              >
                Health<span className="font-extrabold">+</span>
              </span>
            )}
            <div className="z-index-1 absolute mx-auto -mt-6 flex w-full items-center justify-center md:-mt-6">
              {recipe?.adultOnly && (
                <div className="mx-auto inline-flex text-center font-serif text-sm md:mt-1 ">
                  <span className="rounded-full bg-[#D1D5DA] px-2 py-2">
                    Unsuitable for puppies & pregnant/nursing dogs
                  </span>
                </div>
              )}
            </div>
            <LinkRoute href={recipe.url}>
              {/* rounded-full w-48 sm:w-60*/}
              <div
                key={`div-${recipe?.title}`}
                onMouseOver={() => {
                  setIsMouseOver(true)
                }}
                onMouseOut={() => {
                  setIsMouseOver(false)
                }}
                className="my-o relative mx-auto h-48 w-full overflow-hidden group-hover:opacity-75 sm:h-60 lg:aspect-none"
              >
                {!isMouseOver && (
                  <CdnImage
                    className="object-cover object-center rounded-t-3xl"
                    url={recipe?.cdnPreCookedImage}
                    alt={recipe?.title}
                    steps={[330]}
                    style={{
                      width: '330px',
                      height: '330px',
                      maxHeight: '100%',
                      maxWidth: '100%'
                    }}
                  />

                  // <>
                  //   {recipe?.cdnPreCookedImage ? (
                  //     <CdnImage
                  //       className="object-cover object-center"
                  //       url={recipe?.cdnPreCookedImage}
                  //       alt={recipe?.title}
                  //       steps={[330]}
                  //       style={{
                  //         width: '330px',
                  //         height: '330px',
                  //         maxHeight: '100%',
                  //         maxWidth: '100%'
                  //       }}
                  //     />
                  //   ) : (
                  //     <CloudinaryImage
                  //       className="object-cover object-center"
                  //       publicId={recipe?.cloudinaryPreCookImage?.public_id}
                  //       alt={recipe?.title}
                  //       steps={[330]}
                  //       loading={'lazy'}
                  //       style={{
                  //         width: '330px',
                  //         height: '330px',
                  //         maxHeight: '100%',
                  //         maxWidth: '100%'
                  //       }}
                  //     />
                  //   )}
                  // </>
                )}
                <CdnImage
                  className={`object-cover object-center ${isMouseOver ? 'block' : 'hidden'}`}
                  url={recipe?.cdnCookedImage}
                  alt={recipe?.title}
                  steps={[330]}
                  style={{
                    width: '330px',
                    height: '330px',
                    maxHeight: '100%',
                    maxWidth: '100%'
                  }}
                />
              </div>
            </LinkRoute>
            <div className="mt-5 h-full px-4 sm:px-5">
              <div className="flex h-full flex-col justify-between">
                <h4 className="text-base text-gray-700 sm:text-lg" style={{ color: articleTitleTextColor }}>
                  <LinkRoute href={recipe.url}>
                    {/* <span aria-hidden="true" className="absolute inset-0"></span> */}
                    {recipe.title}
                  </LinkRoute>
                </h4>
                <p className="mt-1 flex-1 text-sm text-gray-500" style={{ color: articleDescriptionTextColor }}>
                  {recipe.description}
                </p>
                <ul className="mt-2">
                  {recipeFeature?.length > 0 &&
                    recipeFeature?.map((item: any) => (
                      <li className="flex items-end">
                        <img src={recipeBulletPoint || Bullet} className="mr-2 h-8 w-8" alt={bulletAltText} />
                        <p className="text-sm">{item.feature}</p>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </>
      )
    })
  }

  return (
    <>
      <div className={`${isCarousel ? 'hidden' : 'block'} bg-white md:block`} style={{ backgroundColor }}>
        <div className="mx-auto max-w-2xl py-4 px-4 sm:py-4 sm:px-4 lg:max-w-7xl lg:px-8">
          <div className="card-container mt-6 grid grid-cols-2 gap-x-2 gap-y-10 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
            {getRecipes()}
          </div>
        </div>
      </div>
      {isCarousel && (
        <div className="relative block px-8 pt-4 pb-4 md:hidden" style={{ backgroundColor }}>
          <Slider {...carouselSettings}>{getRecipes()}</Slider>
        </div>
      )}
    </>
  )
}

export default RecipeLister

export const RecipeListerProps = {
  name: 'RecipeLister',
  inputs: [
    {
      name: 'maxNumberToList',
      type: 'number',
      defaultValue: 0,
      description: 'Default is set to 0. When its 0 the component will display all blogs that are available.'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F5F1ED'
    },
    {
      name: 'articleTitleTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'articleDescriptionTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'articleItemBackgroundColor',
      type: 'color',
      defaultValue: '#dce7f7'
    },
    {
      name: 'autoplayTime',
      type: 'number',
      defaultValue: 3000
    },
    {
      name: 'recipeBulletPoint',
      type: 'file',
      defaultValue: Bullet
    },
    {
      name: 'bulletAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'maxNumberOfFeature',
      type: 'number',
      defaultValue: 3,
      description: 'Default is set to 3. When its 0 the component will display all blogs that are available.'
    },
    {
      name: 'isCarousel',
      type: 'boolean',
      defaultValue: true
    }
  ]
}

Builder.registerComponent(RecipeLister, {
  ...RecipeListerProps
})
